import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-courier-tcs',
  templateUrl: './courier-tcs.component.html',
  styleUrls: ['./courier-tcs.component.css']
})
export class CourierTcsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
